import React from 'react';
import { Description } from '../../components/layouts';
import { getTrack } from '../../helpers';
import './style.scss';

const track = getTrack({ block: 30 });

export function Remarks() {
  return (
    <div className="page-section section-remarks inverted" data-track={track}>
      <div className="section-content">
        <Description className="caption">备注：</Description>
        <ol>
          <li>原力配色机器重约178g、厚约7.59mm，华彩机器重约179g、厚约7.69mm。</li>
          <li>工艺原力配色机器后盖采用传统AG工艺，华彩机器后盖采用缎面AG工艺。</li>
          <li>开启畸变矫正后广角度数为 108°。</li>
          <li>由于手机系统和预装的程序占据了部分运存空间，实际运存空间少于 12GB。</li>
          <li>Powered by Multi-Turbo。</li>
          <li>对比上一代X50 Pro，X60 Pro顺序读取速度提升108%、顺序写入速度提升513%，数据会因存储配置不同存在差异。</li>
          <li>
            屏幕刷新率默认为智能切换，根据场景自动切换刷新率，以降低功耗，您可自行前往系统设置中选择智能切换、60Hz、120Hz模式；部分游戏场景最高支持240Hz采样率，不同应用或游戏界面下，屏幕刷新率及触控采样率可能略有不同，请以实际情况为准。
          </li>
          <li>
            页面内的手机外观示意图、内部结构图及产品效果仅供参考，实际可能因光线环境、生产批次的不同，存在颜色、丝印等细节差异，请以实物为准。
          </li>
          <li>
            以上页面的数据及参数为我司实验室标准环境下的测试结果，部分数据为峰值数据，数据及参数的实际情况会因测试环境、测试软件等不同略有差异。
          </li>
          <li>不同拍摄模式的像素可能存在差异，部分样张大小经过裁剪，仅供参考，请以实际拍摄效果为准。</li>
          <li>
            由于产品的某些规格、参数、零部件、外观细节（例如：电池盖有无丝印）可能因供应商更换或生产批次等原因发生变化，vivo
            将根据调整实时更新页面内的描述，请您仔细查看。
          </li>
          <li>
            X60 Pro 使用第三方贴膜会影响屏幕指纹识别效果，请务必使用“vivo 屏幕指纹官方定制膜”。请注意贴膜时不能覆盖听筒微缝，贴 3D
            钢化膜使用胶水时，不要流入受话器微缝及侧按键里面。
          </li>
          <li>屏幕尺寸为按照标准矩形测量的屏幕直角对角线的长度，实际可视区域略小。</li>
          <li>
            本产品 5G 网络支持 SA & NSA 模式，SA 支持能力取决于可用的网络和软件版本；5G
            网络具体组网情况及网络覆盖范围，以运营商实际部署为准。
          </li>
          <li>ZEISS，ZEISS标识，是卡尔蔡司的注册商标。</li>
        </ol>
      </div>
    </div>
  );
}
